import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {TranslocoService} from "@jsverse/transloco";
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Store} from "@ngrx/store";
import {GlobalService} from 'app/global/global.service';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {filter, takeUntil} from "rxjs";
import {CoreSidebarService} from "../../../../../../../@core/components/core-sidebar/core-sidebar.service";
import {CustomColumnService} from "../../../../contract-control/custom-column-service/custom-column.service";
import {DocumentListingApiService} from "../../../../documents/document-listing.api.service";
import {IDocumentTypesDto} from "../../../../documents/dto/document-listing.dto";
import {DocumentListingFacade} from "../../../../documents/store/document-listing.facade";
import {ContractControlEmitterService} from "../../../../events/contract-control-emitter.service";
import {DocumentFieldService} from '../../../documentfields/documentfield.service';
import {MetaDataSectionEnum} from "../../../documentfields/meta-data.helper";
import {DocumentTypeService} from '../../document-type.service';
import {DocumentTypeFacade} from "../../store/document-type.facade";
import {EditLayoutCallableViewEnum} from "../contract-control-edit-layout/edit-layout-callable.enum";
import {DocumentTypeGroupEnum} from "../default-constants/document-type-settings.constants";
import {DocumentTypeAbstractComponent} from "../document-type-abstract.component";
import {IField, IGroup} from "../document-type-settings.dto";
import {TabStateService} from "../tab-state.service";
import { CustomBoxBuilderService } from '../contract-control-edit-layout/custom-box/custom-box-builder.service';

export interface DocumentTypeSettings {
    id: number;
    user_id: number;
    workspace_id: number;
    document_type: string;
    is_default: number;
    document_setting: [];
}

@Component({
  selector: 'app-document-layout-settings',
  templateUrl: './document-layout-settings.component.html',
  styleUrl: './document-layout-settings.component.scss'
})
export class DocumentLayoutSettingsComponent  extends DocumentTypeAbstractComponent implements OnInit {

    @Output() closeSidebar: EventEmitter<void> = new EventEmitter<void>();
    @Output() hiddenEditlayoutViewClick: EventEmitter<string | void> = new EventEmitter();
    @Input() layoutsetting: IDocumentTypesDto;
    @Input() section: MetaDataSectionEnum;
    @Input() view: EditLayoutCallableViewEnum = EditLayoutCallableViewEnum.ContractControl;

    public editLayoutCallableViewEnum = EditLayoutCallableViewEnum;
    public selectedFields$: Set<number> = new Set();
    public updateLayoutSettingsRequestState$ = this._documentTypeFacade.updateLayoutSettingsRequestState$;
    public disabledAccordionSection = [DocumentTypeGroupEnum.Document]

    constructor(
        private contractControlEmitter: ContractControlEmitterService,
        private activeModal: NgbActiveModal,

        protected _activeModal: NgbActiveModal,
        protected _modalService: NgbModal,
        protected _coreSidebarService: CoreSidebarService,
        protected _globalService: GlobalService,
        protected _documentTypeService: DocumentTypeService,
        protected _documentListingApiService: DocumentListingApiService,
        protected _store: Store,
        protected _documentFieldService: DocumentFieldService,
        protected _documentFacade: DocumentListingFacade,
        protected _customColumnService: CustomColumnService,
        protected _transloco: TranslocoService,
        protected _formBuilder: FormBuilder,
        protected _sharedStoreFacade: SharedStoreFacade,
        protected _documentTypeFacade: DocumentTypeFacade,
        protected _tabStateService: TabStateService,
        protected _customBoxBuilderService: CustomBoxBuilderService
    ) {
        super(
            _activeModal,
            _modalService,
            _coreSidebarService,
            _globalService,
            _documentTypeService,
            _documentListingApiService,
            _store,
            _documentFieldService,
            _documentFacade,
            _customColumnService,
            _transloco,
            _formBuilder,
            _sharedStoreFacade,
            _tabStateService,
            _documentTypeFacade,
            _customBoxBuilderService
        );
    }



    ngOnInit(): void {
        this._documentTypeFacade.selectDocumentTypeLayoutSettings$?.pipe(
            filter(x => x !== null),
            takeUntil(this.destroy$)
        ).subscribe((settings) => {
            this.documentTypeSettings = structuredClone(settings);
        });
    }



    /**
     * Handles the drop event for rearranging contract control layout boxes via drag-and-drop.
     *
     * This method clones the current section's boxes, reorders them based on the drag event,
     * updates their order property, and then updates the state with the new box order.
     *
     * @param event - The drag-and-drop event containing previous and current indices of the moved item.
     */
    drop(event: CdkDragDrop<string[]>): void {
        const sections = structuredClone(this.layoutsetting.sections.find(s => s.name === this._tabStateService.getActiveTab()))
        const boxes = structuredClone(sections.boxes);
        moveItemInArray(boxes, event.previousIndex, event.currentIndex);
        boxes.forEach((box, index) => {
            box.order = index;
        });
        this.updateBoxesInState(boxes);
    }





    updateFieldsOrders($event: { nestedTab: DocumentTypeGroupEnum, fields: IField[] }): void {
        this.updateFieldsInState($event.nestedTab, $event.fields);
    }





    /**
     * Updates the visibility status of a specific box in the layout.
     *
     * @param $event - An object containing the index of the box (`boxIndex`) and its new visibility status (`isVisible`).
     */
    updateVisibility($event: { boxIndex: number, isVisible: boolean }): void {
        this.updateDefaultBoxStatus($event.boxIndex, $event.isVisible);
    }





    /**
     * Close modal
     * @param response
     */
    closeModal(response = null) {
        if (this.view === EditLayoutCallableViewEnum.DocumentTypeSetting) {
            this.activeModal.close();
        }
        else if (this.view === EditLayoutCallableViewEnum.ContractControl) {
            this.contractControlEmitter.dispatchEditLayoutSetting(response);
        }
        else if (this.view === EditLayoutCallableViewEnum.ContractControlAddon) {
            this.hiddenEditlayoutViewClick.emit('add'); // to empty document type data from addon page
        }

    }

    updateGroupsOrders(groups: IGroup[]): void {
          if (!this.activeTabSections?.length) {
            this._globalService.toastrError('Active tab not found');
            return;
        }
        this.activeTabSections.forEach(section => {
            section.groups = groups;
        });
        this._documentTypeFacade.updateLayoutSettingsInState(this.documentTypeSettings);
    }
}
